var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableDropDownButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_9592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03931 16.6179C3.62837 16.6179 0.0393066 13.0289 0.0393066 8.61792C0.0393066 4.20698 3.62837 0.61792 8.03931 0.61792C12.4502 0.61792 16.0393 4.20698 16.0393 8.61792C16.0393 13.0289 12.4502 16.6179 8.03931 16.6179ZM8.03931 1.95073C4.36274 1.95073 1.37212 4.94136 1.37212 8.61792C1.37212 12.2945 4.36274 15.2851 8.03931 15.2851C11.7159 15.2851 14.7065 12.2945 14.7065 8.61792C14.7065 4.94136 11.7159 1.95073 8.03931 1.95073Z",
    fill: "#00B6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94932 12.7974C6.71716 12.7974 6.48499 12.7079 6.30608 12.5311C5.95038 12.1754 5.95038 11.6003 6.30608 11.2468L8.84495 8.70791L6.30821 6.16904C5.95251 5.81334 5.95251 5.23826 6.30821 4.88469C6.66391 4.529 7.23899 4.529 7.59255 4.88469L10.7725 8.06467C11.1282 8.42037 11.1282 8.99545 10.7725 9.34902L7.59255 12.5311C7.41577 12.7079 7.18148 12.7974 6.94932 12.7974Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_9592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0393066 0.61792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDropDownButtonIcon);
export default __webpack_public_path__ + "static/media/TableDropDownButtonIcon.feb645868366a65e7d55a946f50bcca2.svg";
export { ForwardRef as ReactComponent };